import React, { useEffect, useState } from 'react'
import useSWR from 'swr'
import fetcher from '@lib/fetcher'

const AdminStockItemsList = () => {
  const { data: stockItems } = useSWR('/merchandise', fetcher)
  const [search, setSearch] = useState('')
  const [filteredItems, setFilteredItems] = useState([])

  useEffect(() => {
    if (stockItems) {
      if (search) {
        setFilteredItems(
          stockItems.filter((item) =>
            item.name.toLowerCase().includes(search.toLowerCase())
          )
        )
      } else {
        setFilteredItems(stockItems)
      }
    }
  }, [stockItems, search])

  if (!stockItems) {
    return <div className="text-gray-600 dark:text-gray-400">Loading...</div>
  }

  return (
    <div className="flex flex-col space-y-4">
      <div className="flex items-center justify-between">
        <div className="font-semibold text-gray-900 dark:text-white">
          Merchandise Items ({filteredItems.length})
        </div>
      </div>

      <input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search by name..."
        className="px-3 py-2 border rounded-md border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      {filteredItems.length === 0 && (
        <div className="text-gray-600 dark:text-gray-400 text-center py-8">
          {search ? 'No items match your search' : 'No merchandise items synced from Spektrix yet'}
        </div>
      )}

      <div className="space-y-2">
        {filteredItems.map((item) => (
          <div
            key={item.id}
            className="flex items-center justify-between px-4 py-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <a
              href={`/merchandise/${item.slug}/edit`}
              className="flex items-center space-x-3 flex-1"
              data-turbolinks="false"
            >
              {item.image_url && (
                <img
                  src={item.image_url}
                  alt={item.name}
                  className="w-12 h-12 object-cover rounded"
                />
              )}
              <div className="flex flex-col">
                <span className="font-medium text-gray-900 dark:text-white">{item.name}</span>
                <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                  <span>Stock: {item.stock_level || 0}</span>
                  <span>•</span>
                  <span>Price: £{(item.price || 0).toFixed(2)}</span>
                  {item.postage_and_packing > 0 && (
                    <>
                      <span>•</span>
                      <span>P&P: £{(item.postage_and_packing || 0).toFixed(2)}</span>
                    </>
                  )}
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AdminStockItemsList
